import { useState } from 'react';
import SlaList from './List.jsx';
import SlaForm from './Form.jsx';
import SlaDetail from './Detail.jsx';

export default function SlaPage() {
  const [view, setView] = useState('list');
  const [selection, setSelection] = useState(null);

  if (view === 'form') {
    return (
      <SlaForm
        slaId={selection}
        onCancel={() => {
          setView('list');
          setSelection(null);
        }}
        onSaved={(id) => {
          setSelection(id ?? null);
          setView('detail');
        }}
      />
    );
  }

  if (view === 'detail' && selection) {
    return (
      <SlaDetail
        slaId={selection}
        onBack={() => {
          setView('list');
          setSelection(null);
        }}
        onEdit={(id) => {
          setSelection(id);
          setView('form');
        }}
      />
    );
  }

  return (
    <SlaList
      onCreate={() => {
        setSelection(null);
        setView('form');
      }}
      onSelect={(sla) => {
        setSelection(sla.id);
        setView('detail');
      }}
    />
  );
}
